import React from "react";

import { Modal, ModalBody } from "reactstrap";

import { isRichTextInputEmpty as checkRichText, RichTextInput } from "components/rich-text-input.tsx/rich-text-input";
import { IRichTextPlaceholderProps } from "../interfaces";
import { GT, ModalWrapper } from "components/index";
import { getNestedObjValue } from "../helpers";

import "./richtext-placeholder.styles.scss";

export const RichTextPlaceholder = ({ rowData, value = undefined }: IRichTextPlaceholderProps) => {
    const { row, fieldName, header } = rowData;

    const content = value || getNestedObjValue(row, fieldName.split("."));

    const isRichTextInputEmpty = !!content ? checkRichText(content) : true;

    if (isRichTextInputEmpty) return <></>;

    return (
        <div className="richtext-placeholder input-placeholder d-flex justify-content-center">
            <ModalWrapper
                key={`prime-input-select-${fieldName}-${row.id}`}
                tooltipContent={<RichTextInput value={content} readOnly />}
                icon={{ name: ["fas", "magnifying-glass"] }}
            >
                {(modalOpen, closeModal) => <ModalContent modalOpen={modalOpen} closeModal={closeModal} value={content} header={header} />}
            </ModalWrapper>
        </div>
    );
};

interface IModalContent {
    modalOpen: boolean;
    value: string;
    header: string;
    closeModal: () => void;
}

const ModalContent = ({ modalOpen, closeModal, value, header }: IModalContent) => {
    return (
        <Modal isOpen={modalOpen} fade toggle={closeModal} onContextMenu={(e) => e.stopPropagation()}>
            <GT.ModalHeader closeModal={closeModal} name={header} />
            <ModalBody>
                <RichTextInput value={value} readOnly />
            </ModalBody>
            <GT.ModalFooter closeModal={closeModal} cancelName="Close" />
        </Modal>
    );
};
